export const FONT_AWESOME_ICON_PREFIX = "fa:";

export const LEGACY_SVG_TO_FA_MAP: Record<string, string> = {
  "Air-Pump.svg": "fa-solid fa-tire-flat",
  "Auto-Repair-Shop.svg": "fa-solid fa-garage",
  "Automobile.svg": "fa-solid fa-car",
  "Battery.svg": "fa-solid fa-car-battery",
  "Car-Headlight.svg": "fa-solid fa-lightbulb",
  "Car-Health.svg": "fa-solid fa-heart-pulse",
  "Car-Items-Checklist.svg": "fa-solid fa-list-check",
  "Car-Jack.svg": "fa-solid fa-screwdriver-wrench",
  "Car-Lifter.svg": "fa-solid fa-screwdriver-wrench",
  "Car-Light-Bulb.svg": "fa-solid fa-lightbulb",
  "Car-Meters.svg": "fa-solid fa-gauge-high",
  "Car-Repair-I.svg": "fa-solid fa-screwdriver-wrench",
  "Car-Repair-II.svg": "fa-solid fa-screwdriver-wrench",
  "Car-Settings.svg": "fa-solid fa-gears",
  "Car-Shifter.svg": "fa-solid fa-joystick",
  "Car-Wash.svg": "fa-solid fa-car-wash",
  "Car-infront-of-Garage.svg": "fa-solid fa-garage-open",
  "Changing-Tyre.svg": "fa-solid fa-tire",
  "Checking-Tyre-Pressure.svg": "fa-solid fa-gauge-high",
  "Cleaning-Windshield.svg": "fa-solid fa-spray-can",
  "Engine-Fan.svg": "fa-solid fa-fan",
  "Engine-Motor.svg": "fa-solid fa-engine",
  "Fixing-Punctured-Tyre.svg": "fa-solid fa-tire-flat",
  "Flywheel.svg": "fa-solid fa-gear",
  "Fuel-Consumption.svg": "fa-solid fa-gas-pump",
  "Fuel-Gauge.svg": "fa-solid fa-gauge-high",
  "Fumes-from-Engine.svg": "fa-solid fa-smog",
  "Glass-Cleaner.svg": "fa-solid fa-spray-can",
  "Horn.svg": "fa-solid fa-bullhorn",
  "Mechanic.svg": "fa-solid fa-user-gear",
  "Oil-Can.svg": "fa-solid fa-oil-can",
  "Oil-Jug.svg": "fa-solid fa-oil-can",
  "Piston.svg": "fa-solid fa-gears",
  "Pressure-Check.svg": "fa-solid fa-tire-flat",
  "Repair-Engine-Motor.svg": "fa-solid fa-engine-warning",
  "Screw-Driver.svg": "fa-solid fa-screwdriver",
  "Seat-Belt.svg": "fa-solid fa-seat",
  "Service-Station.svg": "fa-solid fa-gas-pump",
  "Shifter.svg": "fa-solid fa-joystick",
  "Spark-Plug.svg": "fa-solid fa-bolt",
  "Speedometer.svg": "fa-solid fa-gauge-high",
  "Spray-Bottle.svg": "fa-solid fa-spray-can",
  "Steering-Wheel.svg": "fa-solid fa-steering-wheel",
  "Timing-Belt.svg": "fa-solid fa-gear",
  "Tools.svg": "fa-solid fa-toolbox",
  "Tyre-Air-Pressure-Checke.svg": "fa-solid fa-tire-flat",
  "Tyre-I.svg": "fa-solid fa-tire",
  "Tyre-II.svg": "fa-solid fa-tire",
  "Tyre-Repair.svg": "fa-solid fa-tire-flat",
  "Windshield.svg": "fa-solid fa-input-pipe",
  "Wire-Cutter.svg": "fa-solid fa-scissors",
  "Working-on-Engine.svg": "fa-solid fa-car-wrench",
  "Wrench-in-Hand.svg": "fa-solid fa-wrench",
  "ac.svg": "fa-solid fa-snowflake",
  "brakes.svg": "fa-solid fa-gear",
  "noise.svg": "fa-solid fa-waveform-lines",
  "not-starting.svg": "fa-solid fa-car-key",
  "oil-change.svg": "fa-solid fa-oil-can",
  "oil.svg": "fa-solid fa-oil-can",
  "scheduled-maintenance.svg": "fa-solid fa-calendar-days",
  "scheduled.svg": "fa-solid fa-calendar-check",
  "something-else.svg": "fa-solid fa-ghost",
  "tires.svg": "fa-solid fa-tire",
  "warning-light.svg": "fa-solid fa-engine-warning",
};

export const isFontAwesomeServiceIcon = (icon?: string): boolean =>
  typeof icon === "string" && icon.startsWith(FONT_AWESOME_ICON_PREFIX);

export const getFontAwesomeClassFromIconValue = (icon?: string): string | null => {
  if (!icon || !isFontAwesomeServiceIcon(icon)) {
    return null;
  }

  const className = icon
    .slice(FONT_AWESOME_ICON_PREFIX.length)
    .trim();

  return className || null;
};

export const mapLegacySvgToFa = (svgName?: string): string | null => {
  if (!svgName) {
    return null;
  }

  return LEGACY_SVG_TO_FA_MAP[svgName] || null;
};
